// @ts-expect-error tinymce not typed

import { Alignments } from 'rich-text-lib/constants/alignments';
const isValid = num => num != null && !isNaN(Number(num));

// Resizes { width, height } to { maxWidth, maxHeight} if necessary
// while keeping the original aspect ratio, or just the width if height is invalid
export const resizeAssetDimensions = (maxContainerWidth, width, height) => {
  if (isValid(maxContainerWidth) && isValid(width) && width > maxContainerWidth) {
    if (isValid(height)) {
      const aspectRatio = height / width;
      height = Math.round(aspectRatio * maxContainerWidth);
    }
    // Always resize width dimension
    width = maxContainerWidth;
  }
  return {
    width,
    height
  };
};

// Returns the { width, height } corresponding to the max dimensions
// of the original aspect ratio
export const getMaxDimensions = (maxContainerWidth, width, height) => {
  let maxWidth;
  let maxHeight;
  if (isValid(maxContainerWidth) && isValid(width) && isValid(height)) {
    const aspectRatio = height / width;
    maxHeight = Math.round(aspectRatio * maxContainerWidth);
    maxWidth = maxContainerWidth;
  }
  return {
    width: maxWidth,
    height: maxHeight
  };
};

// Returns the alignment of the given node
export const getAlignment = node => {
  let alignment = Alignments.NONE;
  const styles = node.getAttribute('style');
  const styleMap = node.style;
  if (styles) {
    if (styleMap.float === 'left') {
      alignment = Alignments.LEFT;
    } else if (styleMap.float === 'right') {
      alignment = Alignments.RIGHT;
    } else if (styleMap.display === 'block' || styleMap.margin === 'auto') {
      alignment = Alignments.CENTER;
    }
  }
  return alignment;
};

// Returns the computed value of the margin unless it is "auto"
const getAdjustedMarginValue = (editor, node, marginType, computedValue) => {
  const value = editor.dom.getStyle(node, marginType);
  return value === 'auto' ? value : parseInt(computedValue, 10);
};

// Returns the margins of the specified node
export const getMargins = (editor, node) => {
  const {
    marginLeft,
    marginRight,
    marginTop,
    marginBottom
  } = getComputedStyle(node);
  const margins = {
    left: getAdjustedMarginValue(editor, node, 'margin-left', marginLeft),
    right: getAdjustedMarginValue(editor, node, 'margin-right', marginRight),
    top: parseInt(marginTop, 10),
    bottom: parseInt(marginBottom, 10)
  };
  return margins;
};

// Sets the attributes and innerHTML of the `sourceNode` to the `targetNode`
export function retainAttributesAndInnerHtml(editor, sourceNode, targetNode) {
  let attrName;
  let attrValue;
  let ai;

  // Prefix all attributes except width, height and style since we
  // will add these to the placeholder
  const attribs = sourceNode.attributes;
  ai = attribs.length;
  while (ai--) {
    attrName = attribs[ai].name;
    attrValue = attribs[ai].value;
    if (attrName !== 'width' && attrName !== 'height' && attrName !== 'style' && attrName.indexOf('data-mce-') < 0) {
      if (attrName === 'data' || attrName === 'src') {
        attrValue = editor.convertURL(attrValue, attrName);
      }
      targetNode.attr(`data-mce-p-${attrName}`, attrValue);
    }
  }

  // Place the inner HTML contents inside an escaped attribute
  // This enables us to copy/paste the fake object
  const innerHtml = sourceNode.name !== 'iframe' && sourceNode.firstChild && sourceNode.firstChild.value.trim();
  if (innerHtml) {
    targetNode.attr('data-mce-html', encodeURI(innerHtml));
    targetNode.firstChild = null;
  }
}
const cssUnits = ['px', 'pt', 'cm', 'mm', 'in', 'em', 'rem', 'vh', 'vw', '%', 'ex', 'ch', 'pc', 'vmin', 'vmax'];
const cssUnitRegex = new RegExp(`^[0-9]+(?:${cssUnits.join('|')})$`);

// Returns the `dimension` with proper css units
export const toDimensionAttribute = (dimension, unitsAvailable = true) => {
  if (/^[0-9]+$/.test(dimension)) {
    return `${dimension}${unitsAvailable ? 'px' : ''}`;
  }
  if (cssUnitRegex.test(dimension) && unitsAvailable) {
    return dimension;
  }
  // return undefined so object key-value is not set (so delete isn't necessary)
  return undefined;
};
export const CommandToAlignmentMap = {
  justifycenter: Alignments.CENTER,
  justifyleft: Alignments.LEFT,
  justifyright: Alignments.RIGHT,
  justifynone: Alignments.NONE,
  justifyfull: Alignments.JUSTIFY
};
export const getIsAIDynamicToken = category => {
  return category === 'ai_dynamic_token';
};